<template>
	<compact-banner
		:gradient-colors="{ primary: '#4A148C', secondary: '#311B92', tertiary: '#1A0D3D' }"
		:grid-color="'#A072CE8C'"
		css-class="creators-club-promo-banner"
	>
		<div class="creators-club-promo-text-container">
			<div class="creators-club-promo-title">
				<span class="gradient-text">Creator's Club</span>
			</div>
			<div class="creators-club-promo-subtitle">
				Unlock MAX hardware, 100GB storage, $10/month balance, and more!
			</div>
			<div class="creators-club-promo-button">
				<base-button
					@click="setUpsellDialog({ creatorsClub: true })"
					large
					secondary-primary
					style="padding: 0 40px;"
				>
					Learn More
				</base-button>
			</div>
		</div>
	</compact-banner>
</template>

<script>
import CompactBanner from '@/components/PromoBanners/CompactBanner.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { mapActions } from 'vuex'

export default {
	name: 'CreatorsClubPromoBannerCompact',
	components: {
		CompactBanner,
		BaseButton
	},
	methods: {
		...mapActions(['setUpsellDialog'])
	}
}
</script>

<style lang="scss" scoped>
.creators-club-promo-banner {
	.creators-club-promo-text-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		height: 100%;
		width: 100%;
		z-index: 20;
		
		.creators-club-promo-title {
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			font-weight: bold;
			font-size: 32px;
			margin: 0 0 8px 0;
			
			@media (max-width: 959px) {
				font-size: 28px;
			}
		}
		
		.creators-club-promo-subtitle {
			font-size: 16px;
			color: var(--grey-400);
			font-weight: bold;
			text-wrap: normal;
			max-width: 600px;
			margin: 0 0 15px 0;
			line-height: 1.2;
			
			@media (max-width: 959px) {
				font-size: 14px;
				margin-bottom: 12px;
			}
		}
		
		.creators-club-promo-button {
			display: flex;
			justify-content: center;
			width: 100%;
		}
	}
}
</style> 